import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/admin/AuthContext";
import ProtectedRoute from "@/admin/ProtectedRoute";
import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/Login";

// Website
import SiteShell from "@/website/SiteShell";
import Home from "@/website/pages/Home";
import Services from "@/website/pages/Services";
import About from "@/website/pages/About";
import Reviews from "@/website/pages/Reviews";
import { BlogList, BlogDetail } from "@/website/pages/Blog";
import Gallery from "@/website/pages/Gallery";
import FAQ from "@/website/pages/FAQ";
import Contact from "@/website/pages/Contact";
import Quote from "@/website/pages/Quote";
import Locations from "@/website/pages/Locations";
import PublicLanding from "@/pages/PublicLanding";
import PixelTracker from "@/website/PixelTracker";

// Admin dashboard pages (already built)
import Dashboard from "@/pages/Dashboard";
import SeoPage from "@/pages/SeoPage";
import AdsPage from "@/pages/AdsPage";
import CreativesPage from "@/pages/CreativesPage";
import CalendarPage from "@/pages/CalendarPage";
import LocalPage from "@/pages/LocalPage";
import LandingPage from "@/pages/LandingPage";
import ReviewsPage from "@/pages/ReviewsPage";
import CompetitorsPage from "@/pages/CompetitorsPage";
import EmailPage from "@/pages/EmailPage";
import LeadsPage from "@/pages/LeadsPage";
import GalleryPage from "@/pages/GalleryPage";
import MarketingPage from "@/pages/MarketingPage";
import JournalPage from "@/pages/JournalPage";
import Privacy from "@/website/pages/Privacy";
import Terms from "@/website/pages/Terms";
import DataDeletion from "@/website/pages/DataDeletion";
import ThankYou from "@/website/pages/ThankYou";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PixelTracker />
          <Routes>
            {/* Public marketing website */}
            <Route element={<SiteShell />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/data-deletion" element={<DataDeletion />} />
              <Route path="/thank-you" element={<ThankYou />} />
            </Route>

            {/* Public AI-generated campaign landing pages */}
            <Route path="/p/:slug" element={<PublicLanding />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="leads" element={<LeadsPage />} />
              <Route path="marketing" element={<MarketingPage />} />
              <Route path="journal" element={<JournalPage />} />
              <Route path="seo" element={<SeoPage />} />
              <Route path="ads" element={<AdsPage />} />
              <Route path="creatives" element={<CreativesPage />} />
              <Route path="gallery" element={<GalleryPage />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="local" element={<LocalPage />} />
              <Route path="landing" element={<LandingPage />} />
              <Route path="reviews" element={<ReviewsPage />} />
              <Route path="competitors" element={<CompetitorsPage />} />
              <Route path="email" element={<EmailPage />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
